var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDvr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 26H44V28H40V26ZM14 26H18V32H14V26ZM47 11H11C8.79 11 7 12.79 7 15V43C7 45.21 8.79 47 11 47H47C49.21 47 51 45.21 51 43V15C51 12.79 49.21 11 47 11ZM21 32C21 33.7 19.7 35 18 35H11V23H18C19.7 23 21 24.3 21 26V32ZM30.24 35H27.24L23.74 23H26.74L28.74 29.86L30.74 23H33.74L30.24 35ZM47 28C47 29.2 46.2 30.3 45.2 30.8L47 35H44L42.3 31H40V35H37V23H44C45.7 23 47 24.3 47 26V28Z",
    fill: "#067FE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDvr);
export default __webpack_public_path__ + "static/media/icon-dvr.ac6d69a4557351073123af98dd0eda83.svg";
export { ForwardRef as ReactComponent };